module.exports = __webpack_public_path__ + "img/phone.f63468c.svg";